import React from 'react';
import { Badge } from 'src/components/ui/badge';
import { cn } from 'src/lib/utils';

interface RequestIdBadgeProps {
  id: string;
  className?: string;
  variant?: React.ComponentProps<typeof Badge>['variant'];
}

/**
 * Badge component that displays a request ID with copy functionality
 * Typically used in headers or prominent locations
 */
export const RequestIdBadge: React.FC<RequestIdBadgeProps> = ({
  id,
  className,
  variant = 'neutral',
}) => {
  return (
    <Badge variant={variant} className={cn('tw-gap-1 tw-font-mono', className)}>
      <div className={cn('tw-flex tw-items-center tw-gap-1', className)}>
        <span className="tw-select-all tw-font-mono tw-text-sm tw-font-medium">
          {`#${id.slice(0, 6)}`}
        </span>
      </div>
    </Badge>
  );
};
